import rejectedEllipse from '@/assets/kyc/rejected-ellipse.svg';
import rejectedShield from '@/assets/kyc/rejected-shield.png';
import { Medallion } from '@/components/features/Notifications/popups/Medallion';
import { PopupLinkCta } from '@/components/features/Notifications/popups/PopupCta';
import { PopupShell } from '@/components/features/Notifications/popups/PopupShell';

export interface KycRejectedPanelProps {
  /** Backdrop / Escape dismiss. */
  onClose: () => void;
  /** "Contact Support" tap. */
  onContactSupport: () => void;
}

/**
 * "Verification failed" — terminal REJECTED state. Never auto-launches the
 * Sumsub SDK; only an explicit "Try Again" re-enters the verify flow (minting
 * a fresh access token). "Contact Support" is a non-destructive side action —
 * it does not close the gate.
 */
export function KycRejectedPanel({ onClose, onContactSupport }: KycRejectedPanelProps) {
  return (
    <PopupShell open onClose={onClose} testId="kyc-rejected-panel">
      <Medallion
        circleSrc={rejectedEllipse}
        illustrationSrc={rejectedShield}
        tone="neutral"
        size={190}
        illustrationSize={149}
      />
      <div className="flex flex-col items-center gap-3">
        <h2 className="text-3xl font-semibold tracking-[-0.6px] text-ink">Verification failed</h2>
        <p className="max-w-[394px] text-xl leading-[30px] text-ink">
          We couldn&apos;t verify your identity. Make sure your documents are clear and valid, then try again.
        </p>
      </div>
      <div className="flex flex-col items-center gap-4">
        <PopupLinkCta label="Contact Support" onClick={onContactSupport} testId="kyc-rejected-support" />
      </div>
    </PopupShell>
  );
}
